import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LanguageInterceptor } from '@pcplus/core';
import {
  ErrorInterceptor,
  OPERATION_NOT_AUTHORIZED_ACTION
} from '@pcplus/domain-core';
// import { AuthenticationService } from '../services/authentication/authentication.service';
import { AuthInterceptor } from './auth-interceptor';

export const httpInterceptorProviders = [
  {
    provide: OPERATION_NOT_AUTHORIZED_ACTION,
    deps: [MatSnackBar],
    useFactory: (snackBar: MatSnackBar) => {
      return (message: string) => {
        snackBar.open(message, $localize`OK`, {
          duration: 10000
        });
      };
    }
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorInterceptor,
    multi: true,
    deps: [OPERATION_NOT_AUTHORIZED_ACTION]
  },
  // { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true, deps: [AuthenticationService] },
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: LanguageInterceptor, multi: true }
];
